import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connectDeep } from 'redux-utils';

import { installApp, uninstallApp, setSelectedClock } from 'actions/gallery';

import i18n from 'i18n';
import Modal from 'components/Modal';
import InstallFlow from 'models/install-flow';

import InstallButton from './InstallButton';
import PermissionModal from './PermissionModal';
import { UninstallModal } from './UninstallModal';
import { PrivateModal } from './PrivateModal';
export { Progress } from './InstallButton';

class InstallButtonWithPermission extends Component {
  static propTypes = {
    app: PropTypes.shape().isRequired,
    loading: PropTypes.bool,
    showRemove: PropTypes.bool,
    texts: PropTypes.shape().isRequired
  };

  state = {
    showWaitModal: false,
    showPermission: false,
    showUninstallModal: false,
    showPrivateModal: false
  };

  onApprove = async () => {
    this.props.onInstall();
    this.closePermissionModal();
  };

  showWaitModal = () => this.setState({ showWaitModal: true });
  closeWaitModal = () => this.setState({ showWaitModal: false });

  showPermissionModal = () => this.setState({ showPermission: true });
  closePermissionModal = () => this.setState({ showPermission: false });

  openUninstallModal = () => this.setState({ showUninstallModal: true });
  closeUninstallModal = () => this.setState({ showUninstallModal: false });

  showPrivateModal = () => this.setState({ showPrivateModal: true });
  closePrivateModal = () => this.setState({ showPrivateModal: false });

  onInstall = () => {
    const { app, currentlySyncing, requiresSync } = this.props;

    if (app.isClock && currentlySyncing && requiresSync) {
      this.showWaitModal();
      return;
    }

    if (app.isPrivate && !app.hasUpdate && !app.bypassPrivateAppWarning) {
      this.showPrivateModal();
      return;
    }

    this.continueInstall();
  };

  continueInstall = () => {
    const { app, onInstall } = this.props;
    if (app.arePermissionsReady) {
      onInstall();
      return;
    }

    this.showPermissionModal();
  };

  onUninstall = () => {
    const { onUninstall } = this.props;
    onUninstall && onUninstall();
    this.closeUninstallModal();
  };

  renderWaitModal = () => (
    <Modal
      id="WaitModal"
      title={i18n('page.Clock.InstallButtonWaitModal.title')()}
      contentAbove={i18n('page.Clock.InstallButtonWaitModal.content')()}
      buttons={[
        {
          text: i18n('page.Clock.InstallButtonWaitModal.button')(),
          onClick: this.closeWaitModal
        }
      ]}
      onClose={this.closeWaitModal}
    />
  );

  onAcceptPrivate = () => {
    this.closePrivateModal();
    this.continueInstall();
  };

  renderPrivateModal = () => {
    const { app } = this.props;
    return (
      <PrivateModal
        type={app.type.toLowerCase()}
        onClose={this.closePrivateModal}
        onConfirm={this.onAcceptPrivate}
      />
    );
  };

  renderPermissionsModal = () => (
    <PermissionModal
      app={this.props.app}
      onApprove={this.onApprove}
      onClose={this.closePermissionModal}
    />
  );

  render() {
    const { app, loading, showRemove, texts } = this.props;

    return (
      <div>
        <InstallButton
          app={app}
          texts={texts}
          loading={loading}
          showRemove={showRemove}
          onInstall={this.onInstall}
          onUninstall={this.openUninstallModal}
        />
        {this.state.showWaitModal && this.renderWaitModal()}
        {this.state.showPrivateModal && this.renderPrivateModal()}
        {this.state.showPermission && this.renderPermissionsModal()}
        {this.state.showUninstallModal && (
          <UninstallModal
            appName={app.name}
            onClose={this.closeUninstallModal}
            onConfirm={this.onUninstall}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({
  gallery: {
    currentlySyncing,
    triggerWifiConnect: { loading }
  },
  gallery,
  ...state
}) => ({
  currentlySyncing,
  loading,
  requiresSync: InstallFlow.selectFromState({
    ...state,
    gallery
  }).requiresSync
});

const mapDispatchToProps = (dispatch, { app }) => ({
  onInstall: () => {
    dispatch(installApp(app.id));
    if (app.isClock) {
      dispatch(setSelectedClock(app.id));
    }
  },
  onUninstall: () => dispatch(uninstallApp(app.id))
});

export default connectDeep(
  mapStateToProps,
  mapDispatchToProps
)(InstallButtonWithPermission);
